import React from 'react'
import { useStyles } from "../styles";

import EmptyListIcon from "../../../yoello-lib/modules/components/UI/DraggableList/EmptyList";

interface IEmptyList {
  text:string
}
export function EmptyList({ text }:IEmptyList) {
  const classes = useStyles();
  return (
    <div className={classes.emptyList}>
      <EmptyListIcon />
      <div className={classes.textWrapper}>{text}</div>
    </div>
  )
}
